import { createRouter, createWebHashHistory, RouteLocationNormalized, RouteRecordRaw, createWebHistory } from "vue-router"
import mapRule from './config'
import navigatorType from '@/utils/browser'

const isPc = navigatorType()
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: {
      name: 'title',
      keepAlive: true
    },
    children: [
      {
        path: '/',
        name: 'Index',
        component: () => import('../pages/Index.vue'),
        meta: {
          hideBack: true,
          keepAlive: true,
          footActive: "first",
          title: "北纳标物网|标准物质网|标准物质中心",
          content:{
            keywords:"标准物质,标准物质网,标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        },
      },
      {
        path: '/interest',
        name: 'Interest',
        component: () => import('../pages/Interest.vue'),
        meta: {
          title: "感兴趣的人-个人主页-北纳生物",
          content:{
            keywords:"个人中心,关注,北纳标物网",
            description:"北纳标物网个人中心是用户在交流区的个人主页展示，可供用户查看帖子、课堂、文库、圈子及其他版块内容，并包含用户的关注、粉丝、积分、获赞、勋章等详情。客服中心:400-6699-833",
          }
        },
      },
      {
        path: '/news',
        name: 'News',
        component: () => import('../pages/News.vue'),
        meta: {
          keepAlive: true,
          searchType: 'news',
          footActive: "first",
          title: "新闻中心-北纳标物网",
          content:{
            keywords:"标准物质中心,中检所对照品,标准品,标准物质,标准物质网,标物中心,标准样品,标准溶液,新品上市,北纳标物网",
            description:"北纳标物网为您每日更新标准物质领域新闻动态,行业新闻,技术前沿.内容涉及食品,环境,冶金,地质,临床等相关领域,内容丰富全面及时准确"
          }
        },
      },
      {
        path: '/newsdetail',
        name: 'NewsDetail',
        component: () => import('../pages/NewsDetail.vue'),
        meta: {
          hideFooter: true,
          searchType: 'news',
          title: "新闻标题-北纳标物网",
          content:{
            keywords:"标准物质中心,中检所对照品,标准品,标准物质,标准物质网,标物中心,标准样品,标准溶液,新品上市,北纳标物网",
            description:"北纳标物网为您每日更新标准物质领域新闻动态,行业新闻,技术前沿.内容涉及食品,环境,冶金,地质,临床等相关领域,内容丰富全面及时准确"
          }
        },
      },
      {
        path: '/previewdetail',
        name: 'previewDetail',
        component: () => import('../pages/previewDetail.vue'),
        meta: {
          hideFooter: true,
          // searchType: 'news',
          title: "新闻标题-北纳标物网",
          content:{
            keywords:"标准物质中心,中检所对照品,标准品,标准物质,标准物质网,标物中心,标准样品,标准溶液,新品上市,北纳标物网",
            description:"北纳标物网为您每日更新标准物质领域新闻动态,行业新闻,技术前沿.内容涉及食品,环境,冶金,地质,临床等相关领域,内容丰富全面及时准确"
          }
        },
      },
      {
        path: '/library',
        name: 'Library',
        component: () => import('../pages/Library.vue'),
        meta: {
          hideFooter: true,
          title: "文库页面-北纳生物",
          content: {
            keywords:"标准物质,标准物质网,标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/docDetail',
        name: 'DocDetail',
        component: () => import('../pages/DocDetail.vue'),
        meta: {
          hideFooter: true,
          searchType: 'topic',
          title: "文库标题-北纳标物网",
          content:{
            keywords:"标准物质文库,计量检测,论文下载,学习,查阅,标物网",
            description:"北纳标物网文库,为中国计量从业人员提供在线分享文档在线互动式文档分享平台,同时上传文献也可以获取相应积分兑换礼品哦!"
          }
        },
      },
      {
        path: '/forget',
        name: 'Forget',
        component: () => import('../pages/Forget.vue'),
        meta: {
          title: "密码更换-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        },
      },

      {
        path: '/contact',
        name: 'About',
        component: () => import('../pages/About.vue'),
        meta: {
          footActive: "first",
          title: "关于我们-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        },
      },
      {
        path: '/bbs',
        name: 'Topic',
        component: () => import('../pages/Topic.vue'),
        meta: {
          searchType: 'topic',
          footActive: "first",
          title: "帖子列表-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/bbsdetail',
        name: 'TopicDetail',
        component: () => import('../pages/TopicDetail.vue'),
        meta: {
          hideFooter: true,
          searchType: 'topic',
          title: "帖子标题-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        },
      },
      {
        path: '/postTopic',
        name: 'PostTopic',
        component: () => import('../pages/PostTopic.vue'),
        meta: {
          hideFooter: true,
          searchType: 'topic',
          requireAuth: true,
          title: "发现动态-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        },
      },
      {
        path: '/productCategory',
        name: 'ProductCategory',
        meta: {
          footActive: "second",
          title: "标准物质目录-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        },
        component: () => import('../pages/ProductCategory.vue'),
      },
      {
        path: '/product',
        name: 'product',
        meta: {
          name: 'product',
          keepAlive: true,
          searchType: 'product',
          footActive: "second",
          title: "标准物质目录-全部分类",
          content: {
            keywords:"标准物质,标准物质网,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        },
        component: () => import('../pages/Product.vue'),
      },
      {
        path: '/productOfPromotion',
        name: 'productOfPromotion',
        meta: {
          name: 'productOfPromotion',
          keepAlive: true,
          searchType: 'product',
          footActive: "second",
          title: "5折专区，限时特惠，18周年",
          content: {
            keywords: "18周年，5折专区，限时特惠，标准物质,对照品,标准品,国家标准物质中心,伟业计量",
            description: "伟业计量18周年感恩有你，5折专区，限时特惠。国内最大的标准物质一站式采购平台,资质齐全,产品高达20余万种,畅销全国各地 发货快,价格低,一对一专属服务,售后有保障,欢迎点击在线客服咨询订购!",
          }
        },
        component: () => import('../pages/ProductPromotion.vue'),
      },
      {
        path: '/specialProCategory',
        name: 'specialProCategory',
        meta: {
          // footActive: "second",
          title: "产品专项",
          content: {
            keywords: "5750专项标准物质,标准物质,对照品,标准品,国家标准物质中心,伟业计量",
            description: "国内最大的标准物质一站式采购平台,资质齐全,产品高达20余万种,畅销全国各地 发货快,价格低,一对一专属服务,售后有保障,欢迎点击在线客服咨询订购!",
          }
        },
        component: () => import('../pages/SpecialProCategory.vue'),
      },
      {
        path: '/specialProduct',
        name: 'specialProduct',
        meta: {
          name: 'specialProduct',
          keepAlive: true,
          searchType: 'specialProduct',
          // footActive: "second",
          title: "5750专项标准物质",
          content: {
            keywords: "5750专项标准物质,标准物质,对照品,标准品,国家标准物质中心,伟业计量",
            description: "国内最大的标准物质一站式采购平台,资质齐全,产品高达20余万种,畅销全国各地 发货快,价格低,一对一专属服务,售后有保障,欢迎点击在线客服咨询订购!",
          }
        },
        component: () => import('../pages/SpecialProduct.vue'),
      },
      {
        path: '/bncc',
        name: 'Bncc',
        meta: {
          name: 'bncc',
          keepAlive: true,
          searchType: 'bncc',
          footActive: "second",
          title:"微生物菌种，细胞目录-全部分类",
          content:{
            keywords:"细胞库,肿瘤细胞,正常细胞,转化细胞,菌种库,ATCC,标准菌株,菌种购买,微生物菌种保藏中心,北纳生物",
            description:"北纳生物产品涵盖细胞株,菌株,质粒,病毒等种类产品数十万种,应有尽有,微生物一站式采购平台,方便快捷！",
          }
        },
        component: () => import('../pages/Bncc.vue'),
      },
      {
        path: '/:id',
        name: 'productdetail',
        component: () => import('../pages/ProductDetail.vue'),
        meta: {
          hideFooter: true,
          searchType: 'product',
          title: "产品名称-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/:id',
        name: 'bnccdetail',
        component: () => import('../pages/BnccDetail.vue'),
        meta: {
          hideFooter: true,
          searchType: 'bncc',
          // title:"菌种细胞详情页-伟业计量-标准物质网",
          title: "产品名称-北纳生物",
          content:{
            keywords:"细胞库,肿瘤细胞,正常细胞,转化细胞,菌种库,ATCC,标准菌株,菌种购买,微生物菌种保藏中心,北纳生物",
            description:"北纳生物产品涵盖细胞株,菌株,质粒,病毒等种类产品数十万种,应有尽有,微生物一站式采购平台,方便快捷！",
          }
        }
      },
      {
        path: '/standard',
        name: 'standard',
        meta: {
          name: 'standard',
          keepAlive: true,
          searchType: 'standard',
          footActive: "second",
          title: "标准目录-全部分类",
          content: {
            keywords: "标准物质,对照品,标准品,标准物质中心,北纳标物网",
            description: "国内最大的标准物质一站式采购平台,资质齐全,产品高达20余万种,畅销全国各地 发货快,价格低,一对一专属服务,售后有保障,欢迎点击在线客服咨询订购!",
          }
        },
        component: () => import('../pages/Standard.vue')
      },
      {
        path: '/customize',
        name: 'customize',
        meta: {
          name: 'customize',
          hideFooter: true,
          searchType: 'product',
          title: "定制产品-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        },
        component: () => import('../pages/Customize.vue')
      },
      {
        path: '/s/:id/:classId',
        name: 'standarddetail',
        component: () => import('../pages/StandardDetail.vue'),
        meta: {
          hideFooter: true,
          searchType: 'standard',
          // title:"标准详情页-伟业计量-标准物质网",
          title: "标准详情页-北纳标物网",
          content: {
            keywords: "标准物质中心,标准物质网,标准物质,中检所,中检所对照品,标准品,中国标准物质网,标准物质中心,标准物质,标准物质网",
            description: "标准物质网专业提供标准物质,标准品,对照品,试剂与耗材等20余万种,独立研制11大系列标准物质,提供各种单标及混标定制,标准查询,标准图书和计量交流等综合服务,一站式满足您的需求",
          }
        }
      },
      {
        path: '/order',
        name: 'Order',
        component: () => import('../pages/Order.vue'),
        meta: {
          footActive: "third",
          title: "订单管理-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/invoice',
        name: 'Invoice',
        component: () => import('../pages/Invoice.vue'),
        meta: {
          footActive: "third",
          requireAuth: true,
          title: "我的发票-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/intergral',
        name: 'Intergral',
        component: () => import('../pages/Intergral.vue'),
        meta: {
          footActive: "third",
          requireAuth: true,
          title: "积分兑换-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/exchange',
        name: 'Exchange',
        component: () => import('../pages/Exchange.vue'),
        meta: {
          hideFooter: true,
          requireAuth: true,
          title: "积分兑换-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        },
      },
      {
        path: '/exchangeDetail',
        name: 'ExchangeDetail',
        component: () => import('../pages/ExchangeDetail.vue'),
        meta: {
          requireAuth: true,
          title: "积分兑换-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        },
      },


      {
        path: '/intergralRule',
        name: 'IntergralRule',
        component: () => import('../pages/IntergralRule.vue'),
        meta: {
          footActive: "third",
          requireAuth: true,
          title: "积分规则-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        },
      },

      {
        path: '/bill',
        name: 'Bill',
        component: () => import('../pages/Bill.vue'),
        meta: {
          footActive: "third",
          requireAuth: true,
          title: "我的货款-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        },
      },
      {
        path: '/user',
        name: 'UserInfo',
        component: () => import('../pages/UserInfo.vue'),
        meta: {
          hideFooter: true,
          requireAuth: true,
          title: "会员中心-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/foot',
        name: 'FootPrint',
        component: () => import('../pages/FootPrint.vue'),
        meta: {
          footActive: "third",
          requireAuth: true,
          title: "我的足迹-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/message',
        name: 'Message',
        component: () => import('../pages/Message.vue'),
        meta: {
          footActive: "third",
          requireAuth: true,
          title: "我的消息-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/attention',
        name: 'Attention',
        component: () => import('../pages/Attention.vue'),
        meta: {
          footActive: "third",
          requireAuth: true,
          title: "关注用户-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/unsubscribe',
        name: 'Unsubscribe',
        component: () => import('../pages/Unsubscribe.vue'),
        meta: {
          footActive: "third",
          requireAuth: true,
          title: "关注用户-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/collection',
        name: 'Collection',
        component: () => import('../pages/Collection.vue'),
        meta: {
          footActive: "third",
          requireAuth: true,
          title: "我的收藏-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/account',
        name: 'Account',
        component: () => import('../pages/Account.vue'),
        meta: {
          footActive: "third",
          requireAuth: true,
          title: "我的账户-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/changeMobile',
        name: 'ChangeMobile',
        component: () => import('../pages/ChangeMobile.vue'),
        meta: {
          footActive: "third",
          requireAuth: true,
          title: "修改手机号-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/changePwd',
        name: 'ChangePwd',
        component: () => import('../pages/ChangePwd.vue'),
        meta: {
          footActive: "third",
          hideFooter: true,
          title: "修改密码-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/prize',
        name: 'Prize',
        component: () => import('../pages/Prize.vue'),
        meta: {
          footActive: "third",
          requireAuth: true,
          title: "我的奖品-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/suggest',
        name: 'Suggest',
        component: () => import('../pages/Suggest.vue'),
        meta: {
          footActive: "third",
          requireAuth: true,
          title: "我的建议-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/shopCar',
        name: 'ShopCar',
        component: () => import('../pages/ShopCar.vue'),
        meta: {
          footActive: "third",
          title: "购物车-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/coupon',
        name: 'Coupon',
        component: () => import('../pages/Coupon.vue'),
        meta: {
          title: "优惠券-北纳生物",
          footActive: "third",
          content: {
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/Introduction',
        name: 'Introduction',
        component: () => import('../pages/Introduction.vue'),
        meta: {
          title: "我的邀请-北纳生物",
          footActive: "third",
          content: {
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/myInvitation',
        name: 'myInvitation',
        component: () => import('../pages/myInvitation.vue'),
        meta: {
          title: "我的邀请-北纳生物",
          footActive: "third",
          content: {
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/Invitation',
        name: 'Invitation',
        component: () => import('../pages/Invitation.vue'),
        meta: {
          title: "邀请注册-北纳生物",
          footActive: "first",
          hideFooter: true,
          hideBack: true,
          content: {
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/anniversarys',
        name: 'Anniversary2022',
        component: () => import('../operation/Anniversary2022.vue'),
        meta: {
          hideFooter: true,
          title: "北纳生物2023开工有礼-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/submitOrder',
        name: 'SubmitOrder',
        component: () => import('../pages/SubmitOrder.vue'),
        meta: {
          Authentication: true,  // 需要登录认证
          hideFooter: true,
          title: "提交订单-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/updateAddressOfOrder',
        name: 'updateAddressOfOrder',
        component: () => import('../pages/UpdateAddressOfNeiOrder.vue'),
        meta: {
          Authentication: true,  // 需要登录认证
          hideFooter: true,
          title: "地址修改-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/openSearch',
        name: 'OpenSearch',
        component: () => import('../pages/OpenSearch.vue'),
        meta: {
          footActive: "third",
          title: "搜索-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/personal',
        name: 'Personal',
        component: () => import('../pages/Personal.vue'),
        meta: {
          footActive: "third",
          title: "个人主页-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/signIn',
        name: 'signIn',
        component: () => import('../pages/SignIn.vue'),
        meta: {
          footActive: "third",
          requireAuth: true,
          title: "签到界面-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/course',
        name: 'Course',
        component: () => import('../pages/Course.vue'),
        meta: {
          searchType: 'course',
          keepAlive: true,
          footActive: "four",
          title: "培训中心-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        },
      },
      {
        path: '/courseCommentDetail',
        name: 'CourseCommentDetail',
        component: () => import('../pages/CourseCommentDetail.vue'),
        meta: {
          searchType: 'course',
          hideFooter: true,
          title: "课程评论-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        },
      },
      {
        path: '/topicCommentDetail',
        name: 'TopicCommentDetail',
        component: () => import('../pages/TopicCommentDetail.vue'),
        meta: {
          searchType: 'topic',
          hideFooter: true,
          title: "帖子评论-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        },
      },
      {
        path: '/videodetail',
        name: 'videodetail',
        component: () => import('../pages/VideoDetail.vue'),
        meta: {
          hideFooter: true,
          searchType: 'course',
          footActive: "four",
          title: "课程详情-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/livedetail',
        name: 'livedetail',
        component: () => import('../pages/LiveDetail.vue'),
        meta: {
          hideFooter: true,
          searchType: 'course',
          footActive: "four",
          title: "直播详情-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/videoRealtime',
        name: 'videoRealtime',
        component: () => import('../pages/VideoRealtime.vue'),
        meta: {
          hideFooter: true,
          searchType: 'course',
          footActive: "four",
          title: "直播详情-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/videoRealtimeWeiye',
        name: 'videoRealtimeWeiye',
        component: () => import('../pages/VideoRealtimeWeiye.vue'),
        meta: {
          hideFooter: true,
          searchType: 'course',
          footActive: "four",
          // title:"直播详情页-伟业计量-国家标准物质网",
          title: "直播详情页-伟业计量",
          content: {
            keywords: "国家标准物质中心,国家标准物质网,标准物质,中检所,中检所对照品,标准品,中国标准物质网,标准物质中心,国家标准物质,标准物质网",
            description: "国家标准物质网专业提供标准物质,标准品,对照品,试剂与耗材等20余万种,独立研制11大系列国家标准物质,提供各种单标及混标定制,标准查询,标准图书和计量交流等综合服务,一站式满足您的需求",
          }
        }
      },
      {
        //nei
        path: '/addressOfUser',
        name: 'AddressOfUser',
        component: () => import('../pages/AddressOfNei.vue'),
        meta: {
          hideFooter: true,
          Authentication: true,
          footActive: "third",
          requireAuth: true,
          // title:"我的地址-伟业计量-国家标准物质中心",
          title: "我的地址-北纳标物网",
          content: {
            keywords: "国家标准物质中心,国家标准物质网,标准物质,中检所,中检所对照品,标准品,中国标准物质网,标准物质中心,国家标准物质,标准物质网",
            description: "国家标准物质网专业提供标准物质,标准品,对照品,试剂与耗材等20余万种,独立研制11大系列国家标准物质,提供各种单标及混标定制,标准查询,标准图书和计量交流等综合服务,一站式满足您的需求",
          }
        }
      },
      {
        //nei
        path: '/addAddressOfUser',
        name: 'addAddressOfUser',
        component: () => import('../pages/AddAddressOfNei.vue'),
        meta: {
          hideFooter: true,
          footActive: "third",
          requireAuth: true,
          // title:"添加地址-伟业计量-国家标准物质中心",
          title: "添加地址-北纳标物网",
          content: {
            keywords: "国家标准物质中心,国家标准物质网,标准物质,中检所,中检所对照品,标准品,中国标准物质网,标准物质中心,国家标准物质,标准物质网",
            description: "国家标准物质网专业提供标准物质,标准品,对照品,试剂与耗材等20余万种,独立研制11大系列国家标准物质,提供各种单标及混标定制,标准查询,标准图书和计量交流等综合服务,一站式满足您的需求",
          }
        }
      },
      {
        path: '/address',
        name: 'Address',
        component: () => import('../pages/Address.vue'),
        meta: {
          hideFooter: true,
          Authentication: true,
          footActive: "third",
          requireAuth: true,
          title: "我的地址-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/addAddress',
        name: 'addAddress',
        component: () => import('../pages/AddAddress.vue'),
        meta: {
          hideFooter: true,
          footActive: "third",
          requireAuth: true,
          title: "添加地址-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/chat',
        name: 'Chat',
        component: () => import('../pages/Chat.vue'),
        meta: {
          hideFooter: true,
          title: "私信界面-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/orderDetail',
        name: 'OrderDetail',
        component: () => import('../pages/OrderDetail.vue'),
        meta: {
          title:"订单详情页-北纳标物网",
          content:{
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/virtuallyInfo',
        name: 'virtuallyInfo',
        component: () => import('../pages/VirtuallyInfo.vue'),
        meta: {
          title:"订单详情页-北纳标物网",
          content:{
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/neiOrderDetail',
        name: 'NeiOrderDetail',
        component: () => import('../pages/NeiOrderDetail.vue'),
        meta: {
          title:"订单详情页-北纳标物网",
          content:{
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/login',
        name: 'Login',
        component: () => import('../pages/Login.vue'),
        meta: {
          hideFooter: true,
          title:"登录页面-北纳标物网",
          content:{
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/initTel',
        name: 'InitTel',
        component: () => import('../pages/InitTel.vue'),
        meta: {
          hideFooter: true,
          title:"绑定手机号-北纳标物网",
          content:{
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/setPassword',
        name: 'SetPassword',
        component: () => import('../pages/SetPassword.vue'),
        meta: {
          hideFooter: true,
          title: "设置密码-北纳标物网",
          content:{
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/applyInvoice',
        name: 'ApplyInvoice',
        component: () => import('../pages/ApplyInvoice.vue'),
        meta: {
          hideFooter: true,
          title: "申请发票-北纳标物网",
          content:{
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/lottery',
        name: 'Lottery',
        component: () => import('../pages/Lottery.vue'),
        meta: {
          hideFooter: true,
          // title:"大抽奖-伟业计量-标准物质中心",
          title: "大抽奖-北纳标物网",
          content:{
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/startJob',
        name: 'StartJob',
        component: () => import('../operation/StartJob.vue'),
        meta: {
          hideFooter: true,
          // title:"试抽-伟业计量2021开工有礼-伟业计量-标准物质中心",
          title: "试抽-北纳生物开工有礼-北纳标物网",
          content:{
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },

      {
        path: '/startGift',
        name: 'StartGift',
        component: () => import('../operation/StartGift.vue'),
        meta: {
          hideFooter: true,
          title: "北纳生物2022开工有礼-北纳标物网",
          content: {
            keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/workStart2024',
        name: 'workStart2024',
        component: () => import('../operation/workStart2024.vue'),
        meta: {
          hideFooter: true,
          title: "开工活动——幸运大抽奖-北纳标物网",
          content: {
            keywords:"开工活动，好礼送不停,活动，标准物质,标准物质网,国家标准物质中心,北纳标物网,",
            description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/workStart2025',
        name: 'workStart2025',
        component: () => import('../operation/workStart2025.vue'),
        meta: {
          hideFooter: true,
          title: "开工活动——幸运大抽奖-活动-BNCC",
          content: {
            keywords:"开工活动，好礼送不停,活动，生物制品，微生物菌种，科研细胞，BNCC",
            description:"北纳生物产品涵盖细胞株,菌株,质粒,病毒等种类产品数十万种,应有尽有,微生物一站式采购平台,方便快捷！",
          }
        }
      },
      {
        path: '/workStart2026',
        name: 'workStart2026',
        component: () => import('../operation/workStart2026.vue'),
        meta: {
          hideFooter: true,
          title: "开工活动——幸运大抽奖-活动-BNCC",
          content: {
            keywords:"开工活动，好礼送不停,活动，生物制品，微生物菌种，科研细胞，BNCC",
            description:"北纳生物产品涵盖细胞株,菌株,质粒,病毒等种类产品数十万种,应有尽有,微生物一站式采购平台,方便快捷！",
          }
        }
      },
      {
        path: '/staffVote',
        name: 'yearVote',
        component: () => import('../yearVote/yearVote.vue'),
        meta: {
          hideFooter: true,
          title: "员工投票",
          content: {
            keywords:"标准物质,标准物质网,标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
      {
        path: '/staffVoteView',
        name: 'yearVoteView',
        component: () => import('../yearVote/yearVoteView.vue'),
        meta: {
          hideFooter: true,
          title: "员工投票",
          content: {
            keywords:"标准物质,标准物质网,标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
            description:"标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
          }
        }
      },
    ]
  },
  {
    path: '/mine',
    name: 'Mine',
    component: () => import('../views/Mine.vue'),
    meta: {
      Authentication: true,  // 需要登录认证
      footActive: "third",
      requireAuth: true,
      title: "会员中心-北纳标物网",
      content:{
        keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
        description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
      }
    }
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('../views/Search.vue'),
    meta: {
      footActive: "first",
      title: "搜索界面-北纳标物网",
      content:{
        keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
        description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
      }
    }
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('../views/Error.vue'),
    meta: {
      footActive: "first",
      title: "404界面-北纳标物网",
      content:{
        keywords:"标准物质,标准物质网,国家标准物质中心,北纳标物网,中检所标准品,进口标准品,冶金标准样品,药品对照品,试剂与耗材,标物网",
        description:"国家标准物质一站式采购平台,产品涵盖进口标准品,冶金标准样品,药品对照品,试剂,耗材等产品数十万种,方便快捷!客服中心:010-58103778",
      }
    }
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import('../testPage/Index.vue'),
    meta: {
      footActive: "first",
      title: "测试页面-伟业计量-标准物质中心",
    }
  },
  {
    path: '/testKd',
    name: 'TestKd',
    component: () => import('../testPage/TestKd.vue'),
    meta: {
      footActive: "first",
      title: "测试页面-伟业计量-标准物质中心",
    }
  },
  {
    path: '/maintain',
    name: 'Maintain',
    component: () => import('../maintenance/Maintain.vue'),
    meta: {
      footActive: "first",
      title: "系统维护中",
    }
  }

]

function scrollBehavior(to: any, from: any, savedPosition: any) {
  if (savedPosition) {
    return savedPosition
  } else {
    return {
      x: 0,
      y: 0
    }
  }
}


const router = createRouter({
  // history: createWebHashHistory(),
  history: createWebHistory(),
  routes,
  scrollBehavior
})

//  映射路由到pc端
function routerMap(to: RouteLocationNormalized) {
  const name = to.name;
  let path = mapRule[(name as string)];
  const idReg = /\{\{(.*?)\}\}/;
  if (isPc && path) {
    while (idReg.test(path)) {
      const argName = RegExp.$1;
      const id = to.query[argName] || to.params[argName]
      path = path.replace(idReg, id)
    }
    window.location.href = path
  }
}

router.beforeEach((to, from, next) => {
  routerMap(to)
  const href = window.location.href;
  const codeReg = /code=(.*?)&/;
  let code
  if( codeReg.test(href) ){
    code = RegExp.$1
  }
  const token = localStorage.getItem('token') || '';
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.meta.content) {
    const head = document.getElementsByTagName('head');
    const meta = document.createElement('meta');
    const keywords = document.querySelector('meta[name="keywords"]');
    const description = document.querySelector('meta[name="description"]')
    keywords && keywords.setAttribute('content', to.meta.content.keywords)
    description && description.setAttribute('content', to.meta.content.description)
    meta.content = to.meta.content;
    head[0].appendChild(meta)
  }
  const urlReg = /\/#(.*)/ig;
  if (href.match(urlReg)) {
    const urlPath = RegExp.$1;
    window.location.href = urlPath;
    return false
  }
  if (to.path === '/login') {
    if (token && to.query && to.query.redirect) {
      return next(to.query.redirect as string)
    } else {
      return next()
    }
  } else {
    if (to.matched.length === 0) {
      next("/error")
    }
  }

  if (!to.meta.requireAuth) {
    next()
  } else {
    if (token) {
      if (to.matched.length === 0) {
        next("/error")
      }
      next()
    } else {
      if (to.matched.length === 0) {
        next("/error")
      } else if (code) {
        next()
      } else {
        next({
          path: "login",
          query: {
            redirect: to.fullPath
          }
        })
      }
    }
  }
})





export default router
